/**
 * Meta (Facebook) Pixel – SPA route changes.
 * Init + first PageView: public/index.html
 */
export function trackMetaPageView() {
  if (typeof window === "undefined" || typeof window.fbq !== "function") return;
  window.fbq("track", "PageView");
}
